import React from 'react';
import { Layout } from 'antd';

import Sidebar from 'containers/Sidebar';
import Navbar from 'containers/Navbar';
import './style.scss';

const { Content, Sider } = Layout;

const Page = ({ children }) => {
  const onCollapse = () => {};

  const prefixCls = 'page-layout'

  return (
    <Layout className={prefixCls}>
      <Sider width={240}>
        <div className={`${prefixCls}__logo`}>JoyJet</div>
        <Sidebar />
      </Sider>
      <Layout>
        <Navbar />
        <Content className={`${prefixCls}__content`}>{children}</Content>
      </Layout>
    </Layout>
  );
};

export default Page;
